// https://ddnexus.github.io/pagy/resources/javascript/

import { Controller } from "@hotwired/stimulus";
import Pagy from "lib/pagy.mjs"

export default class extends Controller {
  connect() {
    if (!Pagy) return;

    Pagy.init(this.element);
  }
}
